import React from 'react'

function Dashboard() {
  return (
    <div>
      <div className="page-breadcrumb d-flex align-items-center mb-2">
        <div className="breadcrumb-title "></div>
          <h6>Dashboard</h6>
      </div>
    </div>
  )
}
export default Dashboard
